var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finish"},[_c(_vm.gameComponent,{tag:"component",attrs:{"login":_vm.user.full_name,"token":_vm.token,"server":"production","match":_vm.tournamentId},on:{"gameEnd":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }